const qs = require('querystringify');

export default () => {
  let query = qs.parse(window.location.search);
  let queryData;
  if (query.data) {
    try {
      queryData = JSON.parse(decodeURIComponent(query.data));
    } catch (error) {}
  }
  return queryData;
};
